import { Injectable } from '@angular/core';

import { OddsComparerFactory } from '@frontend/sports/odds/feature';

import { BetslipType } from '../../../../../core/betslip-type';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { mapOdds } from '../../reward-tokens.utils';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class SelectionOddsValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.SelectionOdds;
    constructor(private oddsComparerFactory: OddsComparerFactory) {
        super();
    }

    isValid(token: IRewardToken, state: TokenValidationInput): boolean {
        if (!token.selectionLevelMinimumOdds || state.selectedType === BetslipType.Teaser) {
            return true;
        }

        const picks = state.selectedPicks;
        const minOdds = mapOdds(token.selectionLevelMinimumOdds);
        const odds = this.oddsComparerFactory.createComparer(minOdds);

        return picks.every((p) =>
            p.acceptedPrice.price?.nativeOdds
                ? odds.lessOrEqualThan(p.acceptedPrice.price?.nativeOdds)
                : p.currentPrice?.nativeOdds && odds.lessOrEqualThan(p.currentPrice?.nativeOdds),
        );
    }
}
